export default {
  NON_BREAKING_SPACE: 160
};
